import { h, Host } from "@stencil/core";
/**
 * The 'ch-paginator-navigate' component represents the navigation buttons for the 'ch-paginator' component.
 */
export class ChPaginatorNavigate {
    constructor() {
        this.type = undefined;
        this.disabled = undefined;
    }
    /**
     * Event emitted when the navigation button is pressed.
     */
    navigateClicked; // prettier-ignore
    pressedHandler(eventInfo) {
        if (!eventInfo.key || eventInfo.key === "Enter" || eventInfo.key === " ") {
            this.navigateClicked.emit({ type: this.type });
            eventInfo.stopPropagation();
        }
    }
    render() {
        return h(Host, { role: "button", tabindex: "0", disabled: this.disabled });
    }
    static get is() { return "ch-paginator-navigate"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-paginator-navigate.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-paginator-navigate.css"]
        };
    }
    static get properties() {
        return {
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ChPaginatorNavigateType",
                    "resolved": "\"first\" | \"last\" | \"next\" | \"previous\"",
                    "references": {
                        "ChPaginatorNavigateType": {
                            "location": "import",
                            "path": "./ch-paginator-navigate-types",
                            "id": "src/components/paginator/paginator-navigate/ch-paginator-navigate-types.ts::ChPaginatorNavigateType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The type of navigation button."
                },
                "attribute": "type",
                "reflect": true
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Flag indicating if the button is disabled."
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "navigateClicked",
                "name": "navigateClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the navigation button is pressed."
                },
                "complexType": {
                    "original": "ChPaginatorNavigateClickedEvent",
                    "resolved": "ChPaginatorNavigateClickedEvent",
                    "references": {
                        "ChPaginatorNavigateClickedEvent": {
                            "location": "import",
                            "path": "./ch-paginator-navigate-types",
                            "id": "src/components/paginator/paginator-navigate/ch-paginator-navigate-types.ts::ChPaginatorNavigateClickedEvent"
                        }
                    }
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "click",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=ch-paginator-navigate.js.map
